import { PropsWithChildren } from "react"
import styles from "./Button.module.css"

export enum ButtonSize {
  LARGE,
  MEDIUM,
  SMALL
}

export enum ButtonKind {
  PRIMARY,
  SECONDARY,
  SUGGESTED,
  DISCOUNT
}

interface ButtonProps extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>, React.AriaAttributes {
  preventDefault?: boolean
  stopPropagation?: boolean
  size?: ButtonSize
  kind?: ButtonKind
  destructive?: boolean,
  pulseAnimation?: boolean
}

export default function Button({ className, children, kind=ButtonKind.PRIMARY, size = ButtonSize.SMALL, destructive = false, preventDefault = true, stopPropagation = true, pulseAnimation = false, ...rest }: PropsWithChildren<ButtonProps>) {

  return (
    <button className={`
      ${styles.main}
      ${className ?? ''}
      ${size === ButtonSize.SMALL ? 'smallButton' : size === ButtonSize.LARGE ? 'largeButton' : 'mediumButton'}
      ${kind === ButtonKind.SUGGESTED ? styles.suggested : kind === ButtonKind.DISCOUNT ? styles.discount : kind === ButtonKind.SECONDARY ? styles.secondary : styles.primary}
      ${destructive ? styles.destructive : ''}
      `}
      {...rest}
    >
      {children}
      {pulseAnimation && <div className={styles.pulseAnimation}></div>}
    </button>
  )
}
